export const GENERAL_ERROR_MESSAGE = "Something went wrong!"
export const GENERAL_SUCCESS_MESSAGE = "Fetch details successfully !!";
export const GENERAL_SAVE_MESSAGE = "Save successfully !!";